import React from "react";
import ReactDOM from "react-dom";
import DevTools from "./dev-tools";
var DEVTOOLS_CLASS_NAME = "__prosemirror-dev-tools__";
function createPlace() {
  var place = document.querySelector(".".concat(DEVTOOLS_CLASS_NAME));
  if (!place) {
    place = document.createElement("div");
    place.className = DEVTOOLS_CLASS_NAME;
    document.body.appendChild(place);
  } else {
    ReactDOM.unmountComponentAtNode(place);
    place.innerHTML = "";
  }
  return place;
}
function applyDevTools(editorView, props) {
  var place = createPlace();
  ReactDOM.render( /*#__PURE__*/React.createElement(DevTools, {
    editorView: editorView,
    diffWorker: props === null || props === void 0 ? void 0 : props.diffWorker
  }), place);
  return function () {
    ReactDOM.unmountComponentAtNode(place);
  };
}
export default applyDevTools;
export { applyDevTools };